export default "__VITE_ASSET__D2hXY4Wz__"